function generateUniqueName(base: string, existingNames: string[], suffix?: string): string {
    const candidate = suffix ? `${base} (${suffix})` : base;
    const nameSet = new Set(existingNames);
    if (!nameSet.has(candidate)) {
        return candidate;
    }
    let n = 2;
    while (nameSet.has(suffix ? `${base} (${suffix} ${n})` : `${base} ${n}`)) {
        n++;
    }
    return suffix ? `${base} (${suffix} ${n})` : `${base} ${n}`;
}

export default generateUniqueName;
